/*
 * @Author: Yun
 * @Date: 2024-02-05 10:36:03
 * @Last Modified by: Yun
 * @Last Modified time: 2024-02-27 17:02:25
 */
import React from 'react'
import txt from '@images/intro/txt.png'
import person from '@icons/person3.png'
import CgtnJwplayer from '@components/cgtnJwplayer'
import video from '@videos/intro.mp4'
import './index.less'

const PREFIX = 'intro-page'

const IntroPage = (props) => {
    const { id, onNext } = props

    // const onClick = () => {
    //     onNext()
    // }

    return (
        <section className={PREFIX} id={id}>
            <div className={`${PREFIX}-top`}>
                <img className={`${PREFIX}-img ${PREFIX}-txt`} src={txt} alt="" />
                {/* <img
                    className={`${PREFIX}-img ${PREFIX}-btnnpc`}
                    src={btnnpc}
                    alt=""
                    onClick={onClick}
                />
                <img
                    className={`${PREFIX}-img ${PREFIX}-btncppcc`}
                    src={btncppcc}
                    alt=""
                    onClick={onClick}
                /> */}
            </div>
            <div className={`${PREFIX}-bottom`}>
                <CgtnJwplayer
                    className={`${PREFIX}-img ${PREFIX}-iconvideo`}
                    id={`${PREFIX}-video`}
                    videoUrl={video}
                />
                <img className={`${PREFIX}-img ${PREFIX}-person`} src={person} alt="" />
            </div>
        </section>
    )
}

export default IntroPage
